import React from 'react';
import { Card } from '../ui/Card';
import { TicketIcon } from 'lucide-react';
export function CreditVoucherTab() {
  return <div data-id="element-292">
      <Card title="Credit Vouchers" data-id="element-293">
        <div className="flex items-center gap-3 mb-4" data-id="element-294">
          <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center" data-id="element-295">
            <TicketIcon className="w-5 h-5 text-yellow-600" data-id="element-296" />
          </div>
          <div data-id="element-297">
            <h3 className="font-medium" data-id="element-298">No Vouchers</h3>
            <p className="text-sm text-gray-500" data-id="element-299">
              This contact has no credit vouchers
            </p>
          </div>
        </div>
        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-300">
          + Add Voucher
        </button>
      </Card>
    </div>;
}